import { theme } from 'antd';
import { getDownloadURL } from 'library/firebase/fb.utils';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSites } from 'reduxStore/sites/selectors';
import { LeafletMap, Loader } from 'zComponents/atoms';
import { Empty, Flex, Segmented, Space, Typography } from 'zui/Antd';
import GoogleMap from '../GoogleMaps';

const { Text } = Typography;

export default function SiteMapView({ selectedSite }) {
	const {
		token: { colorBgElevated }
	} = theme.useToken();

	const sites = useSelector(selectSites);
	const [showMapView, setShowMapView] = useState(true);

	const siteData = useMemo(() => {
		return sites.find((s) => s.siteID === selectedSite) || {};
	}, [sites, selectedSite]);

	const [siteUrl, setSiteUrl] = useState('');
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (siteData?.url) {
			setLoading(true);
			getDownloadURL(siteData.url)
				.then(setSiteUrl)
				.catch(() => setSiteUrl(''))
				.finally(() => setLoading(false));
		} else {
			setSiteUrl('');
		}
	}, [siteData]);

	return (
		<div
			className='site-map-container'
			style={{
				minHeight: 600,
				textAlign: 'center',
				position: 'relative'
			}}
		>
			<Flex
				style={{
					backgroundColor: colorBgElevated,
					position: 'absolute',
					top: 20,
					left: 10,
					zIndex: 1000,
					borderRadius: 4,
					boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
					width: 'auto'
				}}
			>
				<Space style={{ padding: '4px 12px' }}>
					<Text style={{ fontSize: 14 }}>{siteData?.fullAddress || 'Address not found'}</Text>
				</Space>
			</Flex>

			<Flex
				gap={8}
				style={{
					position: 'absolute',
					top: 20,
					right: 10,
					zIndex: 1000
				}}
			>
				<Segmented
					options={['Map View', 'Site Layout']}
					value={showMapView ? 'Map View' : 'Site Layout'}
					onChange={(val) => setShowMapView(val === 'Map View')}
				/>
			</Flex>

			{/* Main Content */}
			{loading ? (
				<Loader />
			) : (
				<Flex
					align='center'
					justify='center'
					style={{
						overflow: 'hidden',
						width: '100%',
						height: '600px',
						margin: '0 auto'
					}}
				>
					{showMapView ? (
						siteData?.latitude && siteData?.longitude ? (
							<div style={{ width: '100%', height: '100%' }}>
								<GoogleMap
									data={{
										address: [{ latitude: siteData.latitude, longitude: siteData.longitude }],
										markers: [{ latitude: siteData.latitude, longitude: siteData.longitude }]
									}}
								/>
							</div>
						) : (
							<Empty description='No valid location found for this site.' />
						)
					) : siteUrl ? (
						<LeafletMap mapHeight={300} mapWidth={800} scrollWheelZoom url={siteUrl} />
					) : (
						<Empty description='No site layout uploaded for this site.' />
					)}
				</Flex>
			)}
		</div>
	);
}
